import styled, { css } from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const CardHeader = styled.div `
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: ${({ align }) => align};
  flex-wrap: wrap;
  width: 100%;
  padding: ${units(3)};
  gap: ${units(1.25)} 0;
  color: ${color("typeBody")};

  ${(props) => props.headerPaddingEnd &&
    css `
      padding-right: ${props.headerPaddingEnd};
    `};
`;
export const CardHeaderWrapper = styled.div `
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 0;
`;
export const CardHeaderTitleWrapper = styled.div `
  flex-grow: 1;
  display: block;

  ${({ isEndItemFixed }) => isEndItemFixed &&
    `
      max-width: 85%;
    `};
`;
export const CardHeaderTitle = styled.div `
  color: ${color("contrast", { palette: "illustrativeSteelGrey" })};
  ${typeStyle("headerS")};
  width: 100%;
`;
export const CardHeaderSubtitle = styled.div `
  color: ${color("typeSubHeader")};
  ${typeStyle("labelM")};
  margin-top: ${units(1)};
  width: 100%;
`;
export const CardHeaderEnd = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
`;
export const CardHeaderEndFixed = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  position: absolute;
  right: ${units(2)};
  top: ${units(2)};
`;
